import { useEffect, useState } from "react"
import { FormControlLabel, Switch } from "@mui/material"
import { cn } from "../../lib/utils.js"
import { useNavigation } from "../../hooks/use-navigation.js"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip.js"

const getNewLayoutPreference = () => {
  if (typeof window === "undefined") {
    return false
  }
  return localStorage.getItem("use_new_layout") === "true"
}

export function NewLayoutToggle({ collapsed, isMobile }) {
  const { navigateWithLoading } = useNavigation()
  const [useNewLayout, setUseNewLayout] = useState(getNewLayoutPreference)

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined
    }

    const handlePreferenceChange = () => {
      setUseNewLayout(getNewLayoutPreference())
    }

    window.addEventListener("storage", handlePreferenceChange)
    window.addEventListener("newLayoutPreferenceChanged", handlePreferenceChange)

    return () => {
      window.removeEventListener("storage", handlePreferenceChange)
      window.removeEventListener("newLayoutPreferenceChanged", handlePreferenceChange)
    }
  }, [])

  const handleToggle = (event) => {
    const nextValue = event.target.checked
    setUseNewLayout(nextValue)

    if (typeof window !== "undefined") {
      localStorage.setItem("use_new_layout", nextValue.toString())
      window.dispatchEvent(new Event("newLayoutPreferenceChanged"))
    }

    navigateWithLoading(
      nextValue ? "/vendas" : "/listSale",
      nextValue ? "Carregando novo layout..." : "Carregando layout clássico...",
      { replace: true }
    )
  }

  return (
    <div
      className={cn(
        "px-3 py-2",
        collapsed && !isMobile ? "text-center" : ""
      )}
    >
      <FormControlLabel
        className="!m-0 w-full"
        labelPlacement={collapsed && !isMobile ? "top" : "start"}
        control={
          <Tooltip>
            <TooltipTrigger>
              <Switch
                size="small"
                color="info"
                checked={useNewLayout}
                onChange={handleToggle}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#90caf9"
                  },
                  "& .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track": {
                    backgroundColor: "#424242"
                  },
                  "& .MuiSwitch-switchBase:not(.Mui-checked) .MuiSwitch-thumb": {
                    backgroundColor: "#9e9e9e"
                  }
                }}
              />
            </TooltipTrigger>
            <TooltipContent>
              Ative para usar o layout atualizado
            </TooltipContent>
          </Tooltip>
        }
        label={
          <div className={cn(
            "flex gap-2 text-xs text-gray-300",
            collapsed && !isMobile ? "items-center" : ""
          )}>
            <span className="font-semibold text-white">Novo Layout</span>
          </div>
        }
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: collapsed && !isMobile ? "center" : "space-between",
          alignItems: "center",
          flexDirection: collapsed && !isMobile ? "column" : "row",
          gap: 1
        }}
      />
    </div>
  )
}
